/**
 * Les erreurs nommées ne sortent que de deux formats (règle du prof, 03/10/2026,
 * docs/kit/REGLES_EQUIPE.md § 4) : un choix de QCM et une ligne de vrai/faux. Le
 * générateur a construit chacun pour une erreur précise, le code est celui de
 * cette construction, et chaque nom a passé la lecture à l'aveugle.
 *
 * Tout le reste (textes à trous, étiquettes comprises tant que leurs noms n'ont
 * pas été lus, saisie, placer, relier, ordonner…) part SANS code, quel que soit
 * ce que le générateur a rangé. Appliqué par le registre à chaque tirage, pour
 * tous les niveaux ; les tables que des gens gardent pour ces formats sont donc
 * sans effet.
 */

/** Le format nomme-t-il ses erreurs ? */
export const formatNommable = (payload) => {
    const c = payload?.contenu;
    if (!c || typeof c !== 'object') return false;
    const table = (payload.elements_additionnels?.elements || []).some((e) => e && e.type === 'table');
    if (table) return true;
    if (c.subType) return false; // texte_trou, relier, placer, ordonner, classer, construction, aiguilles
    return payload.type === 'qcm' && Array.isArray(c.choix) && c.choix.length > 0;
};

/** Le payload tel que le registre le rend : sans codes sur les formats non nommables. */
export const nettoyerErreurs = (payload) => {
    const c = payload?.contenu;
    if (!c || typeof c !== 'object') return payload;
    const contenu = { ...c };
    let change = false;
    if (!formatNommable(payload) && contenu.erreurs !== undefined) { delete contenu.erreurs; change = true; }
    if (Array.isArray(contenu.cibles_leurres) && contenu.cibles_leurres.some((l) => l && typeof l === 'object' && 'code' in l)) {
        contenu.cibles_leurres = contenu.cibles_leurres.map((l) => {
            if (!l || typeof l !== 'object' || !('code' in l)) return l;
            const { code, ...reste } = l; // eslint-disable-line no-unused-vars
            return reste;
        });
        change = true;
    }
    if (change) payload.contenu = contenu;
    return payload;
};
